<template>
  <div class="layout">
    <aside class="sidebar">
      <!-- <div class="logo">Admin Panel</div> -->
      <nav>
        <ul>
          <li><router-link to="/" exact>档案管理</router-link></li>
          <li><router-link to="/address" exact>地址管理</router-link></li>
          <li><router-link to="/vendor" exact>渠道管理</router-link></li>
          <li><router-link to="/settings" exact>参数设定</router-link></li>
          <!-- <li><router-link to="/settings">Settings</router-link></li> -->
        </ul>
      </nav>
    </aside>
    <div class="main">
      <header class="header">
        <div class="user-info">
          <span>你好，苏德彪</span>
          <!-- <button @click="logout">Logout</button> -->
        </div>
      </header>
      <section class="content">
        <router-view></router-view>
        <!-- 用于显示路由组件 -->
      </section>
    </div>
  </div>
</template>

<script setup>
function logout() {
  // 这里可以添加退出登录逻辑
}
</script>

<style scoped>
.layout {
  display: flex;
  height: 100vh;
  background: #f5f6fa;
}

.sidebar {
  width: 180px;
  color: #fff;
  background: #202020;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  box-shadow: 8px 0 0 0 rgba(0, 0, 0, 0.05);
  border-right: 1px solid #e8e8e8;
}

.sidebar ul li a {
  font-size: 14px;
  font-weight: 300;
}

.logo {
  font-size: 1.5em;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
}
nav ul {
  list-style: none;
  padding: 0;
  margin-top: 100px;
}

/* 控制菜单间隙 */
nav li {
  margin: 25px 0;
}

nav li:hover {
  background: #353535;
}

nav a {
  color: #e3e3e3;
  text-decoration: none;
  padding: 10px 40px;
  display: block;
  border-radius: 4px;
  transition: background 0.2s;
}

nav a.router-link-active {
  background: #2e95ff;
  margin: 0 10px; /* 左右各10px间距 */
  padding: 12px 30px; /* 内部上下8px，左右15px内边距 */
  border-radius: 8px; /* 可选：圆角 */
  font-weight: bold;
  color: #e3e3e3; /* 可选：文字颜色 */
}



.router-link-exact-active {
  font-weight: bold !important;
}

.main {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  background: #fff;
  box-shadow: 0 8px 0px rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid #e8e8e8;
}
.user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}
.content {
  flex: 1;
  padding: 30px;
  background: #f5f6fa;
  overflow-y: auto;
}
button {
  background: #4078c0;
  color: #fff;
  border: none;
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background: #305080;
}
</style>
